$(document).ready(function() {
    var interfaceName = $(document.body).data('interface-name');
    App.init();
    App.topMenu('.js-menu');
    App.topContacts('.js-top-contacts');
    App.catMenu('.js-cat-menu');
    App.fixedHeader('.js-header');
    App.headerSlider('.js-header-slider');
    App.homeCatalog('.js-home-catalog');
    App.aboutCatalog('.js-about-catalog');
    App.actionsSlider('.js-actions');
    App.productsSlider('.js-products');
    App.siblingsSlider('.js-siblings');
    App.productGallery('.js-product');
    App.productionSlider('.js-production');
    App.initCollapse('.js-collapse');
    App.initVacancy('.js-vacancy');
    App.initPopup('.js-popup');
    ymaps.ready(function() {
        App.showMap('.js-map');
        App.buyersMap('.js-bmap');
    });

    if (interfaceName === 'home_page') {
        App.homeVideo('#homeVideo');
    }
});
